import React, { ChangeEvent, Fragment } from "react";
import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import AdminService from "../../../services/adminService";
import Select from "react-select";
import { ICash, IDeposit, IOption, IShift } from "./interface";
import styles from "./deposit.module.css";
import { SingleValue } from "react-select";
import DatePicker, {
  registerLocale,
  setDefaultLocale,
  getDefaultLocale,
} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { tr, enGB } from "date-fns/locale";
import { Button } from "react-bootstrap";
import { CSSTransition } from "react-transition-group";
import { IShiftIdDTO } from "../interface";
import { encodeQueryData } from "../../../util/queryUtil";
import shift from "../../deficit/employeeDeficit";
import { AxiosError, AxiosResponse } from "axios";
import classNames from "classnames";
import Spinner from "../../spinner";
import NotificationModal from "../../notificationModal";
import Collapsible from "react-collapsible";
import DeleteModal from "../deleteModal";
import { useDispatch, useSelector } from 'react-redux';
import { setGlobalAlert } from '../../../state/action-creators/alert';
import { State } from "../../../state";

export default function Deposit() {
  const dispatch = useDispatch();
  const languageData = useSelector((state: State) => state.languageReducer);
  const limitOptions: any[] = [
    { value: 20, label: 20 },
    { value: 50, label: 50 },
    { value: 60, label: 60 },
    { value: 70, label: 70 },
    { value: 80, label: 80 },
    { value: 90, label: 90 },
    { value: 100, label: 100 },
    { value: 150, label: 150 },
    { value: 200, label: 200 },
    { value: 250, label: 250 },
  ];
  const [isPatchInProgress, setIsPatchInProgress] = useState(false);
  const [isFetchFailed, setIsFetchFailed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleteModeActive, setIsDeleteModeActive] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteTargetDeposit, setDeleteTargetDeposit] = useState<IDeposit>();
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [isGeneralFilterActive, setIsGeneralFilterActive] = useState(true);
  const [isVerified, setIsVerified] = useState(false);
  const [isShiftLocked, setIsShiftLocked] = useState(true);
  const [isDeposited, setIsDeposited] = useState(true);
  const [isShiftCompleted, setIsShiftCompleted] = useState(false);
  const [sortBy, setSortBy] = useState("asc");
  const [limit, setLimit] = useState<SingleValue<IOption>>(limitOptions[0]);
  const [isAmountFilterActive, setIsAmountFilterActive] = useState(false);
  const [eqAmount, setEqAmount] = useState<number>();
  const [gtAmount, setGtAmount] = useState<number>();
  const [gtEqAmount, setGtEqAmount] = useState<number>();
  const [ltAmount, setLtAmount] = useState<number>();
  const [ltEqAmount, setLtEqAmount] = useState<number>();
  const [isGtFilterActive, setIsGtFilterActive] = useState(false);
  const [isGtEqFilterActive, setIsGtEqFilterActive] = useState(false);
  const [isLtFilterActive, setIsLtFilterActive] = useState(false);
  const [isLtEqFilterActive, setIsLtEqFilterActive] = useState(false);
  const [isEqFilterActive, setIsEqFilterActive] = useState(false);
  const [isDateFilterActive, setIsDateFilterActive] = useState(false);
  const [minDepositDate, setMinDepositDate] = useState<Date>();
  const [maxDepositDate, setMaxDepositDate] = useState<Date>();
  const [deposits, setDeposits] = useState<IDeposit[]>();
  const [isShiftEntityIdSearchActive, setIsShiftEntityIdSearchActive] =
    useState(false);
  const [firstShiftSelectOptions, setFirstShiftSelectOptions] =
    useState<IOption[]>();
  const [lastShiftSelectOptions, setLastShiftSelectOptions] =
    useState<IOption[]>();
  const [firstShift, setFirstShift] = useState<SingleValue<IOption>>();
  const [lastShift, setLastShift] = useState<SingleValue<IOption>>();
  // const queryFirstShiftsEntityId = useQuery().get("firstshiftsentityid");
  // const queryLastShiftsEntityId = useQuery().get("lastshiftsentityid");
  const id = useLocation().pathname.split("/")[3];
  const state = useSelector((state: State) => state);
  const { preferredLanguage } = state.authReducer?.user;

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  useEffect(() => {
    if (id) {
      getDepositFromPathVariable(id);
    }
  }, [id]);

  useEffect(() => {
    registerLocale("enGB", enGB);
    setDefaultLocale("enGB");
    console.log(getDefaultLocale());
    getShiftId();
  }, []);

  const getShiftId = async () => {
    try {
      const response = await AdminService.getShiftId();
      const selectOptions = response.data.map((dto: IShiftIdDTO) => {
        return { value: dto.shiftsEntityId, label: dto.shiftId };
      });
      setFirstShiftSelectOptions(selectOptions);
      setLastShiftSelectOptions(selectOptions);
    } catch (err: any) {
      console.dir(err);
      dispatch(setGlobalAlert(
        err.response?.data?.message || "Cannot reach server.",
        'error',
        err.response?.data?.details
      ));
      setIsFetchFailed(true);
    }
  };

  const handleSearchButtonClick = async () => {
    window.history.pushState("", "", "/admin/deposit");
    setIsLoading(true);
    setIsFetchFailed(false);
    let data = {};
    if (isGeneralFilterActive === true) {
      data = {
        ...data,
        isverified: isVerified,
        isdeposited: isDeposited,
        islocked: isShiftLocked,
        iscompleted: isShiftCompleted,
      };
    }
    if (isAmountFilterActive === true) {
      if (isGtFilterActive === true) {
        data = { ...data, "amount.gt": gtAmount };
      }
      if (isGtEqFilterActive === true) {
        data = { ...data, "amount.gteq": gtEqAmount };
      }
      if (isLtFilterActive === true) {
        data = { ...data, "amount.lt": ltAmount };
      }
      if (isLtEqFilterActive === true) {
        data = { ...data, "amount.lteq": ltEqAmount };
      }
      if (isEqFilterActive === true) {
        data = { ...data, "amount.eq": eqAmount };
      }
    }
    if (isDateFilterActive === true) {
      if (minDepositDate !== null && minDepositDate !== undefined) {
        data = { ...data, mindepositdate: minDepositDate?.toJSON() };
      }
      if (maxDepositDate !== null && maxDepositDate !== undefined) {
        data = { ...data, maxdepositdate: maxDepositDate?.toJSON() };
      }
    }
    if (isShiftEntityIdSearchActive === true) {
      if (firstShift !== null && firstShift !== undefined) {
        data = { ...data, firstshiftsentityid: firstShift.value };
      }
      if (lastShift !== null && lastShift !== undefined) {
        data = { ...data, lastshiftsentityid: lastShift.value };
      }
    }
    if (sortBy !== null && sortBy !== undefined) {
      data = { ...data, sort_by: sortBy };
    }
    if (limit !== null && limit !== undefined) {
      data = { ...data, limit: limit.value };
    }
    console.log(data);
    const queryParams = encodeQueryData(data);
    console.log(queryParams);
    try {
      const response = await AdminService.getDeposit(queryParams);
      const updatedDeposits = response.data.map((deposit: IDeposit) => {
        const updatedShift = deposit.shifts.map((shift: IShift) => {
          const updatedCash = shift.cashes.map((cash: ICash) => {
            return {
              ...cash,
              isCashLoading: false,
              isCashPatchFailed: false,
              isCashSaved: true,
              isDeleteFailed: false,
            };
          });
          return { ...shift, cashes: [...updatedCash] };
        });
        return {
          ...deposit,
          isVerifiedLoading: false,
          isVerifiedPatchFailed: false,
          isVerifiedSaved: true,
          isDeleteFailed: false,
          shifts: [...updatedShift],
        };
      });
      console.log(updatedDeposits);
      setDeposits(updatedDeposits);
      setIsLoading(false);
      setIsFetchFailed(false);
    } catch (err: any) {
      console.dir(err);
      dispatch(setGlobalAlert(
        err.response?.data?.message || "Cannot reach server.",
        'error',
        err.response?.data?.details
      ));
      setIsLoading(false);
      setIsFetchFailed(true);
    }
  };

  const getDepositFromPathVariable = async (id: string) => {
    setIsLoading(true);
    setIsFetchFailed(false);
    console.log(id);
    try {
      const response = await AdminService.getDepositById(id);
      const updatedDeposits = response.data.map((deposit: IDeposit) => {
        const updatedShift = deposit.shifts.map((shift: IShift) => {
          const updatedCash = shift.cashes.map((cash: ICash) => {
            return {
              ...cash,
              isCashLoading: false,
              isCashPatchFailed: false,
              isCashSaved: true,
              isDeleteFailed: false,
            };
          });
          return { ...shift, cashes: [...updatedCash] };
        });
        return {
          ...deposit,
          isVerifiedLoading: false,
          isVerifiedPatchFailed: false,
          isVerifiedSaved: true,
          isDeleteFailed: false,
          showShift: false,
          shifts: [...updatedShift],
        };
      });
      console.log(updatedDeposits);
      setDeposits(updatedDeposits);
      setIsLoading(false);
      setIsFetchFailed(false);
    } catch (err: any) {
      console.dir(err);
      dispatch(setGlobalAlert(
        err.response?.data?.message || "Cannot reach server.",
        'error',
        err.response?.data?.details
      ));
      setIsLoading(false);
      setIsFetchFailed(true);
    }
  };

  const handleChangeIsDepositVerified = async (
    event: any,
    depositId: number
  ) => {
    const isVerified = event.target.value === "true";
    const updatedDepositsOnChange = deposits?.map((deposit: IDeposit) => {
      if (deposit.depositId === depositId) {
        return {
          ...deposit,
          isVerifiedLoading: true,
          isVerifiedPatchFailed: false,
          isVerifiedSaved: false,
          verified: isVerified,
        };
      }
      return deposit;
    });
    setDeposits(updatedDepositsOnChange);
    try {
      const response = await AdminService.patchDeposit(
        { verified: isVerified },
        depositId
      );
      const updatedDepositsOnSuccess = deposits?.map((deposit: IDeposit) => {
        if (deposit.depositId === depositId) {
          return {
            ...deposit,
            isVerifiedLoading: false,
            isVerifiedPatchFailed: false,
            isVerifiedSaved: true,
            verified: isVerified,
          };
        }
        return deposit;
      });
      setDeposits(updatedDepositsOnSuccess);
      dispatch(setGlobalAlert("Deposit status updated successfully", 'success'));
    } catch (err: any) {
      console.dir(err);
      dispatch(setGlobalAlert(
        err.response?.data?.message || "Failed to update deposit status",
        'error',
        err.response?.data?.details
      ));
      if (err.response === undefined || err.response.status === 500) {
        dispatch(setGlobalAlert("Unknown error, please contact admin.", 'error'));
      }
      const updateDepositsOnFail = deposits?.map((deposit: IDeposit) => {
        if (deposit.depositId === depositId) {
          return {
            ...deposit,
            isVerifiedLoading: false,
            isVerifiedSaved: false,
            isVerifiedPatchFailed: true,
            verified: !isVerified,
          };
        }
        return deposit;
      });
      setDeposits(updateDepositsOnFail);
    }
  };

  const handleToggleDeleteModal = () => {
    setShowDeleteModal(!showDeleteModal);
  };

  const handleDeleteDeposit = async () => {
    handleToggleDeleteModal();
    console.log("test");
    console.log(deleteTargetDeposit);
    try {
      if (deleteTargetDeposit !== null && deleteTargetDeposit !== undefined) {
        const response = await AdminService.deleteDeposit(
          deleteTargetDeposit.depositId
        );
        const updatedDeposits = deposits?.filter((deposit: IDeposit) => {
          if (deposit.depositId === deleteTargetDeposit.depositId) {
            return false;
          }
          return true;
        });
        setDeposits(updatedDeposits);
      }
    } catch (err: any) {
      console.dir(err);
      dispatch(setGlobalAlert(
        err.response?.data?.message || "Cannot reach server.",
        'error',
        err.response?.data?.details
      ));
      if (err.response === undefined || err.response.status === 500) {
        dispatch(setGlobalAlert("Unknown error, please contact admin.", 'error'));
      }
      if (deleteTargetDeposit !== null && deleteTargetDeposit !== undefined) {
        const updatedDeposits = deposits?.map((deposit: IDeposit) => {
          if (deposit.depositId === deleteTargetDeposit.depositId) {
            return { ...deposit, isDeleteFailed: true };
          }
          return deposit;
        });
        setDeposits(updatedDeposits);
      }
    }
  };

  const handleChangeIsDeleteModeActive = () => {
    setIsDeleteModeActive(!isDeleteModeActive);
  };
  const handleUpdateClickButtonClick = async (
    depositId: number,
    shiftsEntityId: number,
    shiftCashEntityId: number
  ) => {
    setIsPatchInProgress(true);
    const updatedDeposits = deposits?.map((deposit: IDeposit) => {
      if (deposit.depositId === depositId) {
        const updatedShifts = deposit.shifts.map((shift: IShift) => {
          if (shift.shiftsEntityId === shiftsEntityId) {
            const updatedCashes = shift.cashes.map((cash: ICash) => {
              if (cash.shiftCashEntityId === shiftCashEntityId) {
                return {
                  ...cash,
                  isCashLoading: true,
                  isCashPatchFailed: false,
                  isCashSaved: false,
                  isDeleteFailed: false,
                };
              }
              return cash;
            });
            return { ...shift, cashes: [...updatedCashes] };
          }
          return shift;
        });
        return { ...deposit, shifts: [...updatedShifts] };
      }
      return deposit;
    });

    setDeposits(updatedDeposits);

    let payload = {};
    deposits?.forEach((deposit: IDeposit) => {
      if (deposit.depositId === depositId) {
        deposit.shifts.forEach((shift: IShift) => {
          if (shift.shiftsEntityId === shiftsEntityId) {
            shift.cashes.forEach((cash: ICash) => {
              if (cash.shiftCashEntityId === shiftCashEntityId) {
                payload = { amount: cash.amount, note: cash.note };
              }
            });
          }
        });
      }
    });
    try {
      const response = await AdminService.patchCash(payload, shiftCashEntityId);
      const updatedDeposits = deposits?.map((deposit: IDeposit) => {
        if (deposit.depositId === depositId) {
          const updatedShifts = deposit.shifts.map((shift: IShift) => {
            if (shift.shiftsEntityId === shiftsEntityId) {
              const updatedCashes = shift.cashes.map((cash: ICash) => {
                if (cash.shiftCashEntityId === shiftCashEntityId) {
                  return {
                    ...cash,
                    isCashLoading: false,
                    isCashPatchFailed: false,
                    isCashSaved: true,
                    isDeleteFailed: false,
                  };
                }
                return cash;
              });
              return { ...shift, cashes: [...updatedCashes] };
            }
            return shift;
          });
          return { ...deposit, shifts: [...updatedShifts] };
        }
        return deposit;
      });

      setDeposits(updatedDeposits);
      setIsPatchInProgress(false);
    } catch (err: any) {
      console.dir(err);
      dispatch(setGlobalAlert(
          err.response?.data?.message || "Cannot reach server.",
          'error',
          err.response?.data?.details
      ));
      setShowNotificationModal(true);
      const updatedDeposits = deposits?.map((deposit: IDeposit) => {
        if (deposit.depositId === depositId) {
          const updatedShifts = deposit.shifts.map((shift: IShift) => {
            if (shift.shiftsEntityId === shiftsEntityId) {
              const updatedCashes = shift.cashes.map((cash: ICash) => {
                if (cash.shiftCashEntityId === shiftCashEntityId) {
                  return {
                    ...cash,
                    isCashLoading: false,
                    isCashPatchFailed: true,
                    isCashSaved: false,
                    isDeleteFailed: false,
                  };
                }
                return cash;
              });
              return { ...shift, cashes: [...updatedCashes] };
            }
            return shift;
          });
          return { ...deposit, shifts: [...updatedShifts] };
        }
        return deposit;
      });

      setDeposits(updatedDeposits);
      setIsPatchInProgress(false);
    }
  };

  const handleChangeCashAmount = (
    event: ChangeEvent<HTMLInputElement>,
    depositId: number,
    shiftsEntityId: number,
    shiftCashEntityId: number
  ) => {
    const updatedDeposit = deposits?.map((deposit: IDeposit) => {
      if (deposit.depositId === depositId) {
        const updatedShifts = deposit.shifts.map((shift: IShift) => {
          if (shift.shiftsEntityId === shiftsEntityId) {
            const updatedCashes = shift.cashes.map((cash: ICash) => {
              if (cash.shiftCashEntityId === shiftCashEntityId) {
                return {
                  ...cash,
                  amount: Number.parseFloat(event.target.value),
                  isCashLoading: false,
                  isCashPatchFailed: false,
                  isCashSaved: false,
                  isDeleteFailed: false,
                };
              }
              return cash;
            });

            return { ...shift, cashes: [...updatedCashes] };
          }
          return shift;
        });
        return { ...deposit, shifts: [...updatedShifts] };
      }
      return deposit;
    });
    setDeposits(updatedDeposit);
  };

  const handleChangeCashNote = (
    event: ChangeEvent<HTMLInputElement>,
    depositId: number,
    shiftsEntityId: number,
    shiftCashEntityId: number
  ) => {
    const updatedDeposit = deposits?.map((deposit: IDeposit) => {
      if (deposit.depositId === depositId) {
        const updatedShifts = deposit.shifts.map((shift: IShift) => {
          if (shift.shiftsEntityId === shiftsEntityId) {
            const updatedCashes = shift.cashes.map((cash: ICash) => {
              if (cash.shiftCashEntityId === shiftCashEntityId) {
                return {
                  ...cash,
                  note: event.target.value,
                  isCashLoading: false,
                  isCashPatchFailed: false,
                  isCashSaved: false,
                  isDeleteFailed: false,
                };
              }
              return cash;
            });

            return { ...shift, cashes: [...updatedCashes] };
          }
          return shift;
        });
        return { ...deposit, shifts: [...updatedShifts] };
      }
      return deposit;
    });
    setDeposits(updatedDeposit);
  };

  const handleDeleteButtonClicked = (deposit: IDeposit) => {
    setDeleteTargetDeposit(deposit);
    handleToggleDeleteModal();
  };

  const handleShowShiftButtonClick = (depositId: number) => {
    const updatedDeposits = deposits?.map((deposit: IDeposit) => {
      if (deposit.depositId === depositId) {
        return { ...deposit, showShift: !deposit.showShift };
      }
      return deposit;
    });
    setDeposits(updatedDeposits);
  };

  const handleShowCashButtonClick = (
    depositId: number,
    shiftsEntityId: number
  ) => {
    const updatedDeposits = deposits?.map((deposit: IDeposit) => {
      if (deposit.depositId === depositId) {
        const updatedShifts = deposit?.shifts.map((shift: IShift) => {
          if (shift.shiftsEntityId === shiftsEntityId) {
            return { ...shift, showCash: !shift.showCash };
          }
          return shift;
        });
        return { ...deposit, shifts: updatedShifts };
      }
      return deposit;
    });
    setDeposits(updatedDeposits);
  };

  const handleChangeIsGeneralFilterActive = () => {
    setIsGeneralFilterActive(!isGeneralFilterActive);
  };

  const handleChangeIsDeposited = () => {
    setIsDeposited(!isDeposited);
  };
  const handleChangeIsVerified = () => {
    setIsVerified(!isVerified);
  };

  const handleChangeIsShiftEntityIdSearchActive = () => {
    if (isShiftEntityIdSearchActive === true) {
      setFirstShift(null);
      setLastShift(null);
    }
    setIsShiftEntityIdSearchActive(!isShiftEntityIdSearchActive);
  };

  const handleChangeFirstShift = (option: SingleValue<IOption>) => {
    console.log(option?.value);
    setFirstShift(option);
    if (option == null) {
      setLastShift(option);
    }
    if (
      lastShift == null ||
      (option != null && option?.value > lastShift.value)
    ) {
      setLastShift(option);
      const updatedSelectOptions = firstShiftSelectOptions?.filter(
        (opt: IOption) => {
          if (option && opt.value >= option?.value) {
            return true;
          }
          return false;
        }
      );
      setLastShiftSelectOptions(updatedSelectOptions);
    }
  };

  const handleChangeLastShift = (option: SingleValue<IOption>) => {
    console.log(option?.value);
    setLastShift(option);
  };

  const handleChangeIsDateFilterActive = () => {
    setIsDateFilterActive(!isDateFilterActive);
  };

  const handleChangeLimit = (option: SingleValue<IOption>) => {
    setLimit(option);
  };

  const handleChangeEqFilterCheckbox = () => {
    if (isEqFilterActive === false) {
      setIsGtFilterActive(false);
      setIsGtEqFilterActive(false);
      setIsLtFilterActive(false);
      setIsLtEqFilterActive(false);
    }

    if (isEqFilterActive === true) {
      setEqAmount(undefined);
    }
    setIsEqFilterActive(!isEqFilterActive);
  };

  const handleChangeEqFilterAmount = (event: ChangeEvent<HTMLInputElement>) => {
    const amount = Number.parseFloat(event.target.value);
    setEqAmount(amount);
  };

  const handleChangeGtFilterCheckbox = () => {
    if (isGtFilterActive === false) {
      setIsEqFilterActive(false);
      setIsGtEqFilterActive(false);
    }

    if (isGtFilterActive === true) {
      setGtAmount(undefined);
    }
    setIsGtFilterActive(!isGtFilterActive);
  };

  const handleChangeGtFilterAmount = (event: ChangeEvent<HTMLInputElement>) => {
    const amount = Number.parseFloat(event.target.value);
    if (isLtFilterActive && ltAmount && ltAmount < amount) {
      alert("Gt amount can not be greater than lt amount.");
      event.target.value = "";
    } else if (isLtEqFilterActive && ltEqAmount && ltEqAmount < amount) {
      alert("Gt amount can not be greater than lteq amount.");
      event.target.value = "";
    } else {
      setGtAmount(amount);
    }
  };

  const handleChangeGtEqFilterCheckbox = () => {
    if (isGtEqFilterActive === false) {
      setIsEqFilterActive(false);
      setIsGtFilterActive(false);
    }

    if (isGtEqFilterActive === true) {
      setGtEqAmount(undefined);
    }
    setIsGtEqFilterActive(!isGtEqFilterActive);
  };

  const handleChangeGtEqFilterAmount = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const amount = Number.parseFloat(event.target.value);
    if (isLtFilterActive && ltAmount && ltAmount < amount) {
      alert("Gteq amount can not be greater than lt amount.");
      event.target.value = "";
    } else if (isLtEqFilterActive && ltEqAmount && ltEqAmount < amount) {
      alert("Gteq amount can not be greater than lteq amount.");
      event.target.value = "";
    } else {
      setGtEqAmount(amount);
    }
  };

  const handleChangeLtFilterCheckbox = () => {
    if (isLtFilterActive === false) {
      setIsEqFilterActive(false);
      setIsLtEqFilterActive(false);
    }

    if (isLtFilterActive === true) {
      setLtAmount(undefined);
    }
    setIsLtFilterActive(!isLtFilterActive);
  };

  const handleChangeLtFilterAmount = (event: ChangeEvent<HTMLInputElement>) => {
    const amount = Number.parseFloat(event.target.value);
    if (isGtFilterActive && gtAmount && gtAmount > amount) {
      alert("Lt amount can not be less than gt amount.");
      event.target.value = "";
    } else if (isGtEqFilterActive && gtEqAmount && gtEqAmount > amount) {
      alert("Lt amount can not be less than gteq amount.");
      event.target.value = "";
    } else {
      setLtAmount(amount);
    }
  };

  const handleChangeLtEqFilterCheckbox = () => {
    if (isLtEqFilterActive === false) {
      setIsEqFilterActive(false);
      setIsLtFilterActive(false);
    }

    if (isLtEqFilterActive === true) {
      setLtEqAmount(undefined);
    }
    setIsLtEqFilterActive(!isLtEqFilterActive);
  };

  const handleChangeLtEqFilterAmount = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const amount = Number.parseFloat(event.target.value);
    if (isGtFilterActive && gtAmount && gtAmount > amount) {
      alert("Lteq amount can not be less than gt amount.");
      event.target.value = "";
    } else if (isGtEqFilterActive && gtEqAmount && gtEqAmount > amount) {
      alert("Lteq amount can not be less than gteq amount.");
      event.target.value = "";
    } else {
      setLtEqAmount(amount);
    }
  };

  const handleChangeAmountFilterActive = () => {
    setEqAmount(undefined);
    setGtAmount(undefined);
    setGtEqAmount(undefined);
    setLtAmount(undefined);
    setLtEqAmount(undefined);
    setIsEqFilterActive(false);
    setIsGtFilterActive(false);
    setIsGtEqFilterActive(false);
    setIsLtFilterActive(false);
    setIsLtEqFilterActive(false);
    setIsAmountFilterActive(!isAmountFilterActive);
  };

  const handleChangeIsShiftLocked = () => {
    setIsShiftLocked(!isShiftLocked);
  };

  const handleChangeIsShiftCompleted = () => {
    setIsShiftCompleted(!isShiftCompleted);
  };

  const handleChangeSortBy = (event: ChangeEvent<HTMLInputElement>) => {
    setSortBy(event.target.value);
  };

  const search = () => {
    return (
      <div className={styles.search + " justify-content-center"}>
        <div
          className={styles["shift-filter-section"] + " justify-content-center"}
        >
          <div className={styles["filter_active-checkbox"]}>
            <label>{languageData?.data?.admin?.deposit?.filters?.filterActive}</label>
            <input
              type="checkbox"
              checked={isGeneralFilterActive}
              onChange={handleChangeIsGeneralFilterActive}
            />
          </div>
          <div className={styles["deposit-checkbox"]}>
            <label>{languageData?.data?.admin?.deposit?.filters?.shiftLocked}</label>
            <input
              disabled={!isGeneralFilterActive}
              type="checkbox"
              checked={isShiftLocked}
              onChange={handleChangeIsShiftLocked}
            />
          </div>
          <div className={styles["deposit-checkbox"]}>
            <label>{languageData?.data?.admin?.deposit?.filters?.shiftCompleted}</label>
            <input
              disabled={!isGeneralFilterActive}
              type="checkbox"
              checked={isShiftCompleted}
              onChange={handleChangeIsShiftCompleted}
            />
          </div>
          <div className={styles["deposit-checkbox"]}>
            <label>{languageData?.data?.admin?.deposit?.filters?.deposited}</label>
            <input
              disabled={!isGeneralFilterActive}
              type="checkbox"
              checked={isDeposited}
              onChange={handleChangeIsDeposited}
            />
          </div>
          <div className={styles["deposit-checkbox"]}>
            <label>{languageData?.data?.admin?.deposit?.filters?.depositVerified}</label>
            <input
              disabled={!isGeneralFilterActive}
              type="checkbox"
              checked={isVerified}
              onChange={handleChangeIsVerified}
            />
          </div>
        </div>
        <hr />
        <div className={styles["date-filter-wrapper"]}>
          <div className={styles["date-filter-checkbox"]}>
            <label>{languageData?.data?.admin?.deposit?.filters?.dateFilter}</label>
            <input
              type="checkbox"
              checked={isDateFilterActive}
              onChange={handleChangeIsDateFilterActive}
            />
          </div>
          <CSSTransition
            in={isDateFilterActive}
            timeout={400}
            unmountOnExit
            classNames={{
              enter: styles["filter-enter"],
              enterActive: styles["filter-enter-active"],
              exit: styles["filter-exit"],
              exitActive: styles["filter-exit-active"],
            }}
          >
            <div className={styles["date-pickers"]}>
              <div className={styles["date-picker"]}>
                <label>Start Date</label>
                <DatePicker
                  selectsRange
                  inline
                  selected={minDepositDate}
                  dateFormat="dd/MM/yyyy"
                  onChange={(date: any) => setMinDepositDate(date)}
                  onSelect={(date: any) => setMinDepositDate(date)}
                  locale={preferredLanguage}
                />
              </div>
              <div className={styles["date-picker"]}>
                <label>End Date</label>
                <DatePicker
                  selectsRange
                  inline
                  selected={maxDepositDate}
                  dateFormat="dd/MM/yyyy"
                  onSelect={(date: any) => setMaxDepositDate(date)}
                  onChange={(date: any) => setMaxDepositDate(date)}
                  locale={preferredLanguage}
                />
              </div>
            </div>
          </CSSTransition>
        </div>
        <div className={styles["amount-section-wrapper"]}>
          <div className={styles["amount-filter-checkbox"]}>
            <label>{languageData?.data?.admin?.deposit?.filters?.amountFilter}</label>
            <input
              type="checkbox"
              checked={isAmountFilterActive}
              onChange={handleChangeAmountFilterActive}
            />
          </div>
          <CSSTransition
            in={isAmountFilterActive}
            timeout={400}
            unmountOnExit
            classNames={{
              enter: styles["filter-enter"],
              enterActive: styles["filter-enter-active"],
              exit: styles["filter-exit"],
              exitActive: styles["filter-exit-active"],
            }}
          >
            <div className={styles["amount-filter-table-wrapper"]}>
              <table>
                <thead>
                  <tr>
                    <th className={styles["deposit-custom-th-td"]}>{languageData?.data?.admin?.deposit?.filters?.active}</th>
                    <th className={styles["deposit-custom-th-td"]}></th>
                    <th className={styles["deposit-custom-th-td"]}>{languageData?.data?.admin?.deposit?.filters?.amount}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className={styles["deposit-custom-th-td"]}>
                      <input
                        type="checkbox"
                        onChange={handleChangeEqFilterCheckbox}
                        disabled={
                          isGtFilterActive ||
                          isGtEqFilterActive ||
                          isLtFilterActive ||
                          isLtEqFilterActive
                        }
                      />
                    </td>
                    <td className={styles["deposit-custom-th-td"]}>
                      <label className={isEqFilterActive ? "" : "disableLabel"}>
                        {languageData?.data?.admin?.deposit?.filters?.amountEqual}
                      </label>
                    </td>
                    <td className={styles["deposit-custom-th-td"]}>
                      <input
                        type="number"
                        disabled={!isEqFilterActive}
                        onChange={handleChangeEqFilterAmount}
                        value={`${eqAmount}`}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className={styles["deposit-custom-th-td"]}>
                      <input
                        type="checkbox"
                        onChange={handleChangeGtFilterCheckbox}
                        disabled={isEqFilterActive || isGtEqFilterActive}
                      />
                    </td>
                    <td className={styles["deposit-custom-th-td"]}>
                      <label className={isGtFilterActive ? "" : "disableLabel"}>
                        {languageData?.data?.admin?.deposit?.filters?.amountGreaterThan}
                      </label>
                    </td>
                    <td className={styles["deposit-custom-th-td"]}>
                      <input
                        type="number"
                        disabled={!isGtFilterActive}
                        onChange={handleChangeGtFilterAmount}
                        value={`${gtAmount}`}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className={styles["deposit-custom-th-td"]}>
                      <input
                        type="checkbox"
                        onChange={handleChangeGtEqFilterCheckbox}
                        disabled={isEqFilterActive || isGtFilterActive}
                      />
                    </td>
                    <td className={styles["deposit-custom-th-td"]}>
                      <label
                        className={isGtEqFilterActive ? "" : "disableLabel"}
                      >
                        {languageData?.data?.admin?.deposit?.filters?.amountGreaterThanOrEqual}
                      </label>
                    </td>
                    <td className={styles["deposit-custom-th-td"]}>
                      <input
                        type="number"
                        disabled={!isGtEqFilterActive}
                        onChange={handleChangeGtEqFilterAmount}
                        value={`${gtEqAmount}`}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className={styles["deposit-custom-th-td"]}>
                      <input
                        type="checkbox"
                        onChange={handleChangeLtFilterCheckbox}
                        disabled={isEqFilterActive || isLtEqFilterActive}
                      />
                    </td>

                    <td className={styles["deposit-custom-th-td"]}>
                      <label className={isLtFilterActive ? "" : "disableLabel"}>
                        {languageData?.data?.admin?.deposit?.filters?.amountLessThan}
                      </label>
                    </td>
                    <td className={styles["deposit-custom-th-td"]}>
                      <input
                        type="number"
                        disabled={!isLtFilterActive}
                        onChange={handleChangeLtFilterAmount}
                        value={`${ltAmount}`}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className={styles["deposit-custom-th-td"]}>
                      <input
                        type="checkbox"
                        onChange={handleChangeLtEqFilterCheckbox}
                        disabled={isEqFilterActive || isLtFilterActive}
                      />
                    </td>
                    <td className={styles["deposit-custom-th-td"]}>
                      <label
                        className={isLtEqFilterActive ? "" : "disableLabel"}
                      >
                        {languageData?.data?.admin?.deposit?.filters?.amountLessThanOrEqual}
                      </label>
                    </td>
                    <td className={styles["deposit-custom-th-td"]}>
                      <input
                        type="number"
                        disabled={!isLtEqFilterActive}
                        onChange={handleChangeLtEqFilterAmount}
                        value={`${ltEqAmount}`}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CSSTransition>
        </div>
        <hr />
        {firstShiftSelectOptions && firstShiftSelectOptions.length > 0 && (
          <div className={styles["deposit-shift-id-search-container"]}>
            <div className={styles["deposit-search-checkbox"]}>
              <label>{languageData?.data?.admin?.deposit?.filters?.searchByIdFilter}</label>
              <input
                key="isShiftEntityIdSearchActive"
                type="checkbox"
                value="isShiftEntityIdSearchActive"
                name="isShiftEntityIdSearchActive"
                onChange={handleChangeIsShiftEntityIdSearchActive}
                checked={isShiftEntityIdSearchActive}
              />
            </div>

            <div className={styles["deposit-shift-dropdown-main"]}>
              <div className={styles["deposit-dropdown"]}>
                <label>{languageData?.data?.admin?.deposit?.filters?.firstShift}</label>
                <div className={styles["deposit-react-dropdown"]}>
                  <Select
                    options={firstShiftSelectOptions}
                    value={firstShift}
                    onChange={handleChangeFirstShift}
                    isSearchable={true}
                    isClearable={true}
                    placeholder={languageData?.data?.admin?.deposit?.filters?.enterShiftId}
                    isDisabled={!isShiftEntityIdSearchActive}
                  />
                </div>
              </div>

              <div className={styles["deposit-dropdown"]}>
                <label>{languageData?.data?.admin?.deposit?.filters?.lastShift}</label>
                <div className={styles["deposit-react-dropdown"]}>
                  <Select
                    options={lastShiftSelectOptions}
                    value={lastShift}
                    onChange={handleChangeLastShift}
                    isSearchable={true}
                    isClearable={true}
                    placeholder={languageData?.data?.admin?.deposit?.filters?.enterShiftId}
                    isDisabled={!isShiftEntityIdSearchActive}
                  />
                </div>
              </div>
            </div>

            <hr />
          </div>
        )}
        <div className={styles["deposit-radio-main-div"]}>
          <div className={styles["deposit-radio-div"]}>
            <label>{languageData?.data?.admin?.deposit?.filters?.sortBy}</label>
            <input
              type="radio"
              value="asc"
              onChange={handleChangeSortBy}
              checked={sortBy === "asc"}
            />
          </div>
          <div className={styles["deposit-radio-div"]}>
            <label>{languageData?.data?.admin?.deposit?.filters?.sortByDesc}</label>
            <input
              type="radio"
              value="desc"
              onChange={handleChangeSortBy}
              checked={sortBy === "desc"}
            />
          </div>
          <div className={styles["deposit-dropdown-list"]}>
            <label>{languageData?.data?.admin?.deposit?.filters?.listAmount}</label>
            <Select
              options={limitOptions}
              value={limit}
              onChange={handleChangeLimit}
              isSearchable={false}
            />
          </div>
        </div>
        <hr />
        <Button onClick={handleSearchButtonClick}>{languageData?.data?.admin?.deposit?.filters?.search}</Button>
        <hr />
      </div>
    );
  };

  const table = () => {
    let depositClass: string;
    if (isDeleteModeActive === true) {
      depositClass = "deposit-custom-th-td-8";
    } else {
      depositClass = "deposit-custom-th-td-7";
    }

    return (
      <div className={styles["deposit-table-wrapper"]}>
        {deposits &&
        deposits.length > 0 &&
        isLoading === false &&
        isFetchFailed === false ? (
          <div className={styles["deposit-table-main-thead"]}>
            <div className={styles["shift-search-checkbox"]}>
              <label>{languageData?.data?.admin?.deposit?.filters?.deleteMode}</label>
              <input
                key="isDeleteModeActive"
                type="checkbox"
                value="isDeleteModeActive"
                name="isDeleteModeActive"
                onChange={handleChangeIsDeleteModeActive}
                checked={isDeleteModeActive}
              />
            </div>
            <table className={styles["deposit-main-table"]}>
              <thead>
                <tr>
                  {isDeleteModeActive === true ? (
                    <th className={depositClass}>{languageData?.data?.admin?.deposit?.table?.deleteShift}</th>
                  ) : null}
                  <th className={depositClass}>{languageData?.data?.admin?.deposit?.table?.showShift}</th>
                  <th className={depositClass}>{languageData?.data?.admin?.deposit?.table?.depositId}</th>
                  <th className={depositClass}>{languageData?.data?.admin?.deposit?.table?.depositVerified}</th>
                  <th className={depositClass}>{languageData?.data?.admin?.deposit?.table?.deposited}</th>
                  <th className={depositClass}>{languageData?.data?.admin?.deposit?.table?.date}</th>
                  <th className={depositClass}>{languageData?.data?.admin?.deposit?.table?.totalAmount}</th>
                  <th className={depositClass}>{languageData?.data?.admin?.deposit?.table?.eligibleForVerify}</th>
                </tr>
              </thead>
            </table>
          </div>
        ) : null}

        {deposits &&
          deposits.length > 0 &&
          isLoading === false &&
          isFetchFailed === false &&
          deposits.map((deposit: IDeposit) => {
            return (
              <div
                key={deposit.depositId + "div1"}
                className={styles["deposit-main-div"]}
              >
                <table key={deposit.depositId + "t1"}>
                  <tbody>
                    <tr key={deposit.depositId + "tr1"}>
                      {isDeleteModeActive === true ? (
                        <td
                          className={
                            depositClass +
                            (deposit.isDeleteFailed === true
                              ? " deposit-failed"
                              : "")
                          }
                        >
                          <Button
                            onClick={() => handleDeleteButtonClicked(deposit)}
                            className={styles["delete-btn"]}
                          >
                            {languageData?.data?.admin?.deposit?.table?.delete}
                          </Button>
                        </td>
                      ) : null}
                      <td
                        key={deposit.depositId + "td1"}
                        className={depositClass}
                      >
                        <label className={styles["switch"]}>
                          <input
                            type="checkbox"
                            onClick={() =>
                              handleShowShiftButtonClick(deposit.depositId)
                            }
                          />
                          <span
                            className={styles["slider"] + " " + styles["round"]}
                          ></span>
                        </label>
                      </td>
                      <td
                        key={deposit.depositId + "td2"}
                        className={depositClass}
                      >
                        {deposit.depositId}
                      </td>
                      <td
                        key={deposit.depositId + "td3"}
                        className={classNames(
                          depositClass,
                          {
                            [styles["deposit-loading"]]:
                              deposit.isVerifiedLoading,
                          },
                          {
                            [styles["deposit-failed"]]:
                              deposit.isVerifiedPatchFailed,
                          },
                          {
                            [styles["deposit-notSaved"]]:
                              !deposit.isVerifiedSaved &&
                              !deposit.isVerifiedPatchFailed &&
                              !deposit.isVerifiedLoading,
                          },
                          { [styles["deposit-saved"]]: deposit.isVerifiedSaved }
                        )}
                      >
                        <select
                          disabled={deposit.isVerifiedLoading}
                          value={`${deposit.verified}`}
                          onChange={(event) =>
                            handleChangeIsDepositVerified(
                              event,
                              deposit.depositId
                            )
                          }
                        >
                          <option value="true">✔</option>
                          <option value="false">❌</option>
                        </select>
                      </td>
                      <td
                        key={deposit.depositId + "td4"}
                        className={depositClass}
                      >
                        {deposit.deposited ? (
                          <label>✔</label>
                        ) : (
                          <label>❌</label>
                        )}
                      </td>
                      <td
                        key={deposit.depositId + "td5"}
                        className={depositClass}
                      >
                        {deposit.date}
                      </td>
                      <td
                        key={deposit.depositId + "td6"}
                        className={depositClass}
                      >
                        {deposit.totalAmount}
                      </td>
                      <td
                        key={deposit.depositId + "td7"}
                        className={depositClass}
                      >
                        {deposit.eligibleForVerify
                          ? languageData?.data?.admin?.deposit?.table?.yes
                          : languageData?.data?.admin?.deposit?.table?.no}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div
                  key={deposit.depositId + "div2"}
                  className={classNames(styles["deposit-shift-main"], {
                    "display-none": !deposit.showShift,
                  })}
                >
                  {deposit.shifts && deposit.shifts.length > 0 && (
                    <table
                      key={deposit.depositId + "t2"}
                      className={styles["deposit-shift-table"]}
                    >
                      <thead>
                        <tr>
                          <th className={styles["deposit-custom-th-td-6"]}>
                            <label>{languageData?.data?.admin?.deposit?.table?.showCash}</label>
                          </th>
                          <th className={styles["deposit-custom-th-td-6"]}>
                            {languageData?.data?.admin?.deposit?.table?.shiftId}
                          </th>
                          <th className={styles["deposit-custom-th-td-6"]}>
                            <label>{languageData?.data?.admin?.deposit?.table?.totalAmount}</label>
                          </th>
                          <th className={styles["deposit-custom-th-td-6"]}>
                            <label>{languageData?.data?.admin?.deposit?.table?.eligibleForVerify}</label>
                          </th>
                          <th className={styles["deposit-custom-th-td-6"]}>
                            <label>{languageData?.data?.admin?.deposit?.table?.locked}</label>
                          </th>
                          <th className={styles["deposit-custom-th-td-6"]}>
                            <label>{languageData?.data?.admin?.deposit?.table?.completed}</label>
                          </th>
                        </tr>
                      </thead>
                    </table>
                  )}
                  {deposit.shifts &&
                    deposit.shifts.length > 0 &&
                    deposit.shifts.map((shift: IShift) => {
                      const shiftCashClass = classNames(
                        styles["deposit-shift-cash-main"],
                        { "display-none": !shift.showCash }
                      );
                      return (
                        <div
                          key={
                            deposit.depositId + shift.shiftsEntityId + "div1"
                          }
                          className={
                            deposit.showShift === true ? "" : "display-none"
                          }
                        >
                          <table key={shift.shiftsEntityId}>
                            <tbody>
                              <tr>
                                <td
                                  className={styles["deposit-custom-th-td-6"]}
                                  key={shift.shiftsEntityId + "td1"}
                                >
                                  <label className={styles["switch"]}>
                                    <input
                                      type="checkbox"
                                      onClick={() =>
                                        handleShowCashButtonClick(
                                          deposit.depositId,
                                          shift.shiftsEntityId
                                        )
                                      }
                                    />
                                    <span
                                      className={
                                        styles["slider"] + " " + styles["round"]
                                      }
                                    ></span>
                                  </label>
                                </td>
                                <td
                                  key={shift.shiftsEntityId + "td2"}
                                  className={styles["deposit-custom-th-td-6"]}
                                >
                                  <label>{shift.shiftId}</label>
                                </td>
                                <td
                                  key={shift.shiftsEntityId + "td3"}
                                  className={styles["deposit-custom-th-td-6"]}
                                >
                                  {shift.totalAmount}
                                </td>
                                <td
                                  key={shift.shiftsEntityId + "td4"}
                                  className={styles["deposit-custom-th-td-6"]}
                                >
                                  {shift.eligibleForVerify === true
                                    ? languageData?.data?.admin?.deposit?.table?.yes
                                    : languageData?.data?.admin?.deposit?.table?.no}
                                </td>
                                <td
                                  key={shift.shiftsEntityId + "td5"}
                                  className={styles["deposit-custom-th-td-6"]}
                                >
                                  {shift.locked === true
                                    ? languageData?.data?.admin?.deposit?.table?.yes
                                    : languageData?.data?.admin?.deposit?.table?.no}
                                </td>
                                <td
                                  key={shift.shiftsEntityId + "td6"}
                                  className={styles["deposit-custom-th-td-6"]}
                                >
                                  {shift.completed === true
                                    ? languageData?.data?.admin?.deposit?.table?.yes
                                    : languageData?.data?.admin?.deposit?.table?.no}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          {shift.cashes && shift.cashes.length > 0 && (
                            <div
                              key={shift.shiftsEntityId + "shiftcash"}
                              className={shiftCashClass}
                            >
                              <table>
                                <thead>
                                  <tr>
                                    <th
                                      className={
                                        styles["deposit-custom-th-td-4"]
                                      }
                                    >
                                      {languageData?.data?.admin?.deposit?.table?.employeeName}
                                    </th>
                                    <th
                                      className={
                                        styles["deposit-custom-th-td-4"]
                                      }
                                    >
                                      {languageData?.data?.admin?.deposit?.table?.amount}
                                    </th>
                                    <th
                                      className={
                                        styles["deposit-custom-th-td-4"]
                                      }
                                    >
                                      {languageData?.data?.admin?.deposit?.table?.note}
                                    </th>
                                    <th
                                      className={
                                        styles["deposit-custom-th-td-4"]
                                      }
                                    >
                                      {languageData?.data?.admin?.deposit?.table?.update}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {shift.cashes &&
                                    shift.cashes.length > 0 &&
                                    shift.cashes.map((cash: ICash) => {
                                      const cashClass = classNames(
                                        styles["deposit-custom-th-td-4"],
                                        {
                                          [styles["deposit-notSaved"]]:
                                            !cash.isCashSaved &&
                                            !cash.isCashPatchFailed &&
                                            !cash.isCashLoading,
                                        },
                                        {
                                          [styles["deposit-saved"]]:
                                            cash.isCashSaved,
                                        },
                                        {
                                          [styles["deposit-failed"]]:
                                            cash.isCashPatchFailed,
                                        },
                                        {
                                          [styles["deposit-loading"]]:
                                            cash.isCashLoading,
                                        }
                                      );
                                      return (
                                        <tr
                                          key={
                                            cash.shiftCashEntityId +
                                            shift.shiftId +
                                            "tr"
                                          }
                                        >
                                          <td
                                            key={
                                              cash.shiftCashEntityId +
                                              shift.shiftId +
                                              "td1"
                                            }
                                            className={cashClass}
                                          >
                                            {cash.employeeName}
                                          </td>
                                          <td
                                            key={
                                              cash.shiftCashEntityId +
                                              shift.shiftId +
                                              "td2"
                                            }
                                            className={cashClass}
                                          >
                                            <input
                                              disabled={isPatchInProgress}
                                              key={
                                                cash.shiftCashEntityId +
                                                shift.shiftId +
                                                "in1"
                                              }
                                              type="number"
                                              value={
                                                cash.amount === null
                                                  ? 0
                                                  : cash.amount
                                              }
                                              onChange={(event) =>
                                                handleChangeCashAmount(
                                                  event,
                                                  deposit.depositId,
                                                  shift.shiftsEntityId,
                                                  cash.shiftCashEntityId
                                                )
                                              }
                                            />
                                          </td>
                                          <td
                                            className={cashClass}
                                            key={
                                              cash.shiftCashEntityId +
                                              shift.shiftId +
                                              "td3"
                                            }
                                          >
                                            <input
                                              disabled={isPatchInProgress}
                                              key={
                                                cash.shiftCashEntityId +
                                                shift.shiftId +
                                                "in2"
                                              }
                                              type="text"
                                              value={
                                                cash.note === null
                                                  ? ""
                                                  : cash.note
                                              }
                                              onChange={(event) =>
                                                handleChangeCashNote(
                                                  event,
                                                  deposit.depositId,
                                                  shift.shiftsEntityId,
                                                  cash.shiftCashEntityId
                                                )
                                              }
                                            />
                                          </td>
                                          <td
                                            className={cashClass}
                                            key={
                                              cash.shiftCashEntityId +
                                              shift.shiftId +
                                              "td4"
                                            }
                                          >
                                            <Button
                                              disabled={
                                                cash.isCashLoading ||
                                                isPatchInProgress
                                              }
                                              onClick={() =>
                                                handleUpdateClickButtonClick(
                                                  deposit.depositId,
                                                  shift.shiftsEntityId,
                                                  cash.shiftCashEntityId
                                                )
                                              }
                                            >
                                              {languageData?.data?.admin?.deposit?.table?.update}
                                            </Button>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
              </div>
            );
          })}
      </div>
    );
  };

  return (
    <div className={styles["search-main-div justify-content-center"]}>
      <h1>{languageData?.data?.admin?.deposit?.title}</h1>
      {search()}
      {isLoading === true && isFetchFailed === false ? <Spinner /> : null}
      {isFetchFailed === true && isLoading === false ? (
        <h3>Fetch Failed</h3>
      ) : null}
      {isLoading === false &&
      isFetchFailed === false &&
      deposits &&
      deposits.length === 0 ? (
        <h3>Couldn't find deposit.</h3>
      ) : null}
      {table()}
      <DeleteModal
        isHardDeleteActive={false}
        buttonText="Delete"
        onTrue={handleDeleteDeposit}
        handleClose={handleToggleDeleteModal}
        show={showDeleteModal}
        question={`Would you like to delete deposit id ${deleteTargetDeposit?.depositId}?`}
      />
    </div>
  );
}
